import * as React from 'react';
import { FareFamilyFragment, SegmentFragment } from '@websky/graphql';
import { SimpleFlight } from '../../Results/types';
import Location from '../../Location';
import FlightCard from '../../FlightCard';
import { getDurationString } from '../../Results/utils';
import { useTheme } from '../../theme';
import TransferInfo from '../../TransferInfo';

export interface Props {
	flight: SimpleFlight;
	selectedFareFamily?: FareFamilyFragment;
}

const FlightInfo: React.FC<Props> = ({ flight }) => {
	const { FlightInfo: css } = useTheme('FlightInfo');
	const getNextSegment = (index: number): SegmentFragment => flight.segments[index + 1].segment;

	return (
		<div>
			{flight.segments.map(({ transferDuration, segment }, index) => (
				<div key={segment.flightNumber} className={css.segment}>
					<div className={css.segment__info}>
						<Location className={css.segment__location} type="departure" {...segment.departure} />

						{segment.aircraft && (
							<FlightCard
								className={css.segment__flight}
								airline={segment.operatingAirline}
								flightNumber={`${segment.marketingAirline?.iata}-${segment.flightNumber}`}
								duration={getDurationString(segment.duration)}
								aircraft={segment.aircraft}
								amenities={segment.flightInfo?.amenities}
								markers={segment.flightInfo?.markers}
								statistics={segment.flightInfo?.statistics}
							/>
						)}

						<Location className={css.segment__location} type="arrival" {...segment.arrival} />
					</div>

					{transferDuration && (
						<TransferInfo
							className={css.segment__transfer}
							segment={segment}
							nextSegment={getNextSegment(index)}
							transferDuration={transferDuration}
							showStops={true}
						/>
					)}
				</div>
			))}
		</div>
	);
};

export default FlightInfo;
